manageMediaDisplay = () => {
  const flkty = new Flickity(".product__media-list--carousel", {
    cellAlign: "left",
    contain: true,
    pageDots: false,
    wrapAround: false,
    arrowShape: {
      x0: 10,
      x1: 60,
      y1: 50,
      x2: 65,
      y2: 45,
      x3: 20,
    },
  });

  const currentVariantIdEl = document.querySelector('.product [name="id"]');
  const initialFlktyCells = flkty.getCellElements();
  const additionalVariantData = JSON.parse(document.getElementById("additionalVariantData").textContent);
  const desktopCarouselSlides = document.querySelectorAll(".carousel-wrapper li");
  const carouselNavImages = document.querySelectorAll(".carousel-wrapper--nav li");
  const imagesMobile = document.querySelectorAll(".slider--mobile.product__media-list li");


  init = () => {
    this.initFlktySlideChangeListener();
    this.initNavCellClickListeners();
    this.initVariantChangeListener();

    currentVariantIdEl.dispatchEvent(new Event("change"));
  }


  initVariantChangeListener = () => {
    currentVariantIdEl.addEventListener("change", (event) => {
      let sku = this.getSkuVariantById(event.target.value);
      let skuLower = sku.toLowerCase();

      this.resetFlktySlides();
      this.showHideMediaBySku(skuLower);
      this.showMobileSelectorsBySku(skuLower);
      this.selectFirstCell();
    });
  };


  initFlktySlideChangeListener = () => {
    flkty.on("change", (index) => {
      let cellElements = flkty.getCellElements();
      let cellElement = cellElements[index];

      let mediaId = cellElement.dataset.mediaId;

      if (carouselNavImages.length) {
        for (let thumb of carouselNavImages) thumb.classList.remove("is-selected");
      }

      if (mediaId) {
        let navCell = document.querySelector(`.carousel-wrapper--nav li[data-media-id="${mediaId}"]`);

        navCell.classList.add("is-selected");
      }
    });
  };


  initNavCellClickListeners = () => {
    let carouselNavImages = document.querySelectorAll(".carousel-wrapper--nav li");

    for (let thumb of carouselNavImages) {
      thumb.addEventListener("click", () => {
        for (let thumbInner of carouselNavImages) thumbInner.classList.remove("is-selected");

        thumb.classList.add("is-selected");

        let slideIndex = thumb.dataset.slideIndex;

        flkty.select(slideIndex);
      });
    }
  };


  resetFlktySlides = () => {
    flktyCells = flkty.getCellElements();
    flktyCells.forEach((element) => {
      flkty.remove(element);
    });

    initialFlktyCells.forEach((element) => {
      flkty.insert(element);
    });
  }


  selectFirstCell = () => {
    flkty.select(0);
    flkty.reposition();
  }


  showMobileSelectorsBySku = (sku) => {
    document.dispatchEvent(
      new CustomEvent("variantChanged", { detail: { sku: sku } })
    );
  }


  getSkuVariantById = (variantId) => {
    let variantData = additionalVariantData[variantId];
    if (variantId && variantData && variantData.sku) {
      return variantData.sku;
    }
  }


  hideCarouselImagesBySku = (sku) => {
    desktopCarouselSlides.forEach((element) => {
      if (
        sku === element.dataset.imageVariant.toLowerCase() ||
        !!!element.dataset.imageVariant
      )
        return;

      flkty.remove(element);
    });

    imagesMobile.forEach(function (thumb) {
      if (
        sku === thumb.dataset.imageVariant.toLowerCase() ||
        !!!thumb.dataset.imageVariant
      ) {
        thumb.classList.remove("hidden");
      } else {
        thumb.classList.add("hidden");
      }
    });

    let thumbIndex = 0;

    carouselNavImages.forEach(function (thumb) {
      if (
        sku === thumb.dataset.imageVariant.toLowerCase() ||
        !!!thumb.dataset.imageVariant
      ) {
        thumb.classList.remove("hidden");
        thumb.dataset.slideIndex = thumbIndex;
        thumbIndex++;
      } else {
        thumb.classList.add("hidden");
      }
    });
  }


  displayAllCarouselImages = () => {
    carouselNavImages.forEach(function (thumb) {
      thumb.classList.remove("hidden");
    });

    imagesMobile.forEach(function (thumb) {
      thumb.classList.remove("hidden");
    });
  }


  showHideMediaBySku = (sku) => {
    if (sku) {
      let hasThumb = document.querySelectorAll('.carousel-wrapper--nav li[data-image-variant="' + sku + '"]').length;

      if (hasThumb) {
        this.hideCarouselImagesBySku(sku);
      } else {
        this.displayAllCarouselImages();
      }
    }
  }

  this.init();
}

/** Setting Quantity input to maximum product quantity on keyboard input **/ 
const quantityInput = document.querySelector('.product input[name="quantity"]');
quantityInput.addEventListener('change', function() {
  let qtyMax = quantityInput.getAttribute("max");
  if (qtyMax != null && Number(quantityInput.value) > qtyMax) {
    quantityInput.value = (qtyMax != 0) ? qtyMax : 1;
  }
})


document.addEventListener("DOMContentLoaded", () => {
  manageMediaDisplay();

  
  const currentVariantIdEl = document.querySelector('.product [name="id"]');

  currentVariantIdEl.addEventListener("change", (event) => {
    const additionalVariantData = JSON.parse(
      document.getElementById("additionalVariantData").textContent
    );

    let variantData = additionalVariantData[event.target.value];
    if (variantData && variantData.sku) {
      sku = variantData.sku;
    }

    document.getElementById("current-sku").innerHTML = sku;

    if (event.target.available) {
      quantityInput.setAttribute("max", event.target.available);
    }
  });
});